// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_V81","cls2":"VideoResults-cls2_FxA VideoResults-cls1_V81"};